import styled from 'styled-components';

const MyDiv = styled.div`
table_header {
    background-color: #f9fafb;
  }
`;

export default MyDiv;
